import * as React from 'react';

import './index.scss';

export const BrandingText: React.FC = () => {
    return (
        <div className="container">
            <div className="branding-text">
                <h2>We work with bold brands that feel the difference</h2>
            </div>
        </div>
    );
};
